
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FormPart extends Vue {
    @Prop({required: true})
    part!: number;

    @Prop({required: true})
    title!: string;

    @Prop({required: false})
    subtitle?: string;

}
